import { CanActivateFn, Router } from '@angular/router'
import { inject } from '@angular/core'
import { UsersService } from './users.service'
import { filter, map, take } from 'rxjs'

export const adminGuard: CanActivateFn = () => {
  const usersService = inject(UsersService)
  const router = inject(Router)

  return usersService.getCurrentUser().pipe(
    filter((result) => result.isSuccess || result.isError),
    take(1),
    map((result) => {
      const role = result.data?.role
      if (role === 'ADMIN' || role === 'SUPER') {
        return true
      }
      return router.createUrlTree(['/app'])
    })
  )
}
